<mat-form-field appearance="outline"  style="width: 100%;">
    <mat-label *ngIf="label != ''">{{label}}</mat-label>
    <input
      type="text"
      [placeholder]="placeholder"
      aria-label="Nombre"
      matInput
      [formControl]="control" 
      [matAutocomplete]="auto"
      [disabled]="disabled"
    >

    <mat-icon
    *ngIf="control.value"
    matSuffix
    class="clear-icon"
    (click)="limpiar()"
    tabindex="0"
    role="button"
    aria-label="Borrar"
    [hidden]="disabled"
   >close</mat-icon>

    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayFn"
      (optionSelected)="onOptionSelected($event)"
      panelWidth="450"
    >
      <mat-option  *ngFor="let option of filteredOptions | async" [value]="option">
        {{ option.name }}
      </mat-option>
    </mat-autocomplete>
</mat-form-field>